import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { contactsApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeleteContact = (options?: UseMutationOptions<void, unknown, string>) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(
    ['delete-contact', assetId],
    async (contactId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await contactsApi.contactsControllerRemove(contactId, assetId);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries('fetch-contacts');
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
        trackEvent('Contact', 'delete');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
